import { baseUrl } from "../../../../../utils";
const AccountSkeleton = () => {
    return(
         <div>
            <h4 className="text-dark font-weight-bold  mb-4"><p className="sk_line sk_line_100 sk_line_height_18 mb-0" style={{width:150}}></p></h4>
            <div className="row">
                <div className="col-lg-6 col-md-6">
                    <div className="card card-custom mb-8 bgi-no-repeat" style={{
                        backgroundPosition: "right top",
                        backgroundSize: "30% auto",
                        backgroundImage:
                            `url(${baseUrl('svg/abstract-1.svg')})`,
                        }}>
                        <div className="card-body p-5">
                            <div className="d-flex align-items-center">
                                <div className="me-6">
                                    <span className="sk_rect d-block rounded-circle" style={{height:45, width:45}}></span>
                                </div>
                                <div className="d-flex flex-column w-100">
                                    <h5 className="mb-3 text-gradient h6"><p className="sk_line sk_line_100 sk_line_height_15 mb-0 w-50"></p></h5>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="text-dark-75 w-100"><p className="sk_line sk_line_100 sk_line_height_10 my-1" style={{width:100}}></p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="card card-custom mb-8 bgi-no-repeat" style={{
                        backgroundPosition: "right top",
                        backgroundSize: "30% auto",
                        backgroundImage:
                            `url(${baseUrl('svg/abstract-1.svg')})`,
                        }}>
                        <div className="card-body p-5">
                            <div className="d-flex align-items-center">
                                <div className="me-6">
                                    <span className="sk_rect d-block rounded-circle" style={{height:45, width:45}}></span>
                                </div>
                                <div className="d-flex flex-column w-100">
                                    <h5 className="mb-3 text-gradient h6"><p className="sk_line sk_line_100 sk_line_height_15 mb-0 w-50"></p></h5>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="text-dark-75 w-100"><p className="sk_line sk_line_100 sk_line_height_10 my-1" style={{width:100}}></p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h4 className="text-dark font-weight-bold  mb-4"><p className="sk_line sk_line_100 sk_line_height_18 mb-0" style={{width:120}}></p></h4>
            <div className="row">
                {[...Array(12)].map((item,index)=><div className="col-xl-2-5 col-md-4 col-sm-6 mb-5" key={index}>
                    <div className="card card-custom card-stretch overflow-hidden account_status_card">
                        <div className="card-body text-center p-6">
                            <span className="sk_rect d-block m-auto mb-7 mt-2" style={{height:45, width:45}}></span>
                            <h5 className="card-title font-weight-bold mt-3 mb-4 d-block h6 text-center"><p className="sk_line sk_line_100 sk_line_height_15 my-1 mx-auto" style={{width:70}}></p></h5>
                            <p className="sk_line sk_line_100 sk_line_height_8 my-1 mx-auto" style={{width:110}}></p>
                        </div>
                    </div>
                </div>)}
            </div>
        </div>
    )
}

export default AccountSkeleton;